<div class="padding-dialog">

  <div class='flex event-box'>
    <mat-icon *ngIf="data.icon" svgIcon={{data.icon}} class="svg-icon"></mat-icon>
    <div>
      <h1 mat-dialog-title>{{data.title}}</h1>
      <div mat-dialog-content class="spin-theme">
        <p style="text-align: center;">{{data.message}}</p>
      </div>

    </div>
    <button mat-icon-button mat-dialog-close *ngIf="data.dialogClose">
      <mat-icon>clear</mat-icon>
    </button>
  </div>



  <div mat-dialog-actions align="center">
    <button *ngIf="data.buttonCancelText" mat-flat-button [color]="data.cancelButtonColor"
      mat-dialog-close>{{data.buttonCancelText}}</button>
    <button *ngIf="data.buttonConfirmText" mat-flat-button [color]="data.confirmButtonColor || 'primary'"
      [mat-dialog-close]="true">{{data.buttonConfirmText}}</button>


  </div>
</div>